import * as React from 'react';
import { Skeleton, SkeletonText, Table, TableHeader, TableHeaderItem, TableRow, TableRowItem } from '@moosend/mooskin';

export const TableLoader = () => {
	return (
		<Table>
			<TableHeader>
				<TableHeaderItem justify="center" flex={1.3}>
					<Skeleton>CB</Skeleton>
				</TableHeaderItem>
				<TableHeaderItem flex={10}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
				<TableHeaderItem flex={3}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
				<TableHeaderItem flex={3}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
				<TableHeaderItem flex={3}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
				<TableHeaderItem flex={3}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
				<TableHeaderItem flex={3}>
					<SkeletonText lines={1}>TEXT</SkeletonText>
				</TableHeaderItem>
			</TableHeader>
			{[...Array(10)].map((item, i) => {
				return (
					<TableRow key={i}>
						<TableRowItem justify="center" flex={1.3}>
							<Skeleton>CB</Skeleton>
						</TableRowItem>
						<TableRowItem flex={10}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
						<TableRowItem flex={3}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
						<TableRowItem flex={3}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
						<TableRowItem flex={3}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
						<TableRowItem flex={3}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
						<TableRowItem flex={3}>
							<SkeletonText lines={1}>TEXT</SkeletonText>
						</TableRowItem>
					</TableRow>
				);
			})}
		</Table>
	);
};
